import {Injectable} from '@angular/core';
import {urlJoin} from '../../../../utils/urlJoin';
import {environment} from '../../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';

export interface dataC {
    bidNo: any;
    bidModSeq: any;
}

@Injectable({
    providedIn: 'root',
})
export class CryptageFoService {
    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'fournisseur');
    }

    check(data: dataC) {
        const resource = urlJoin(CryptageFoService.base, 'cryptage', 'status');
        return this.http.put(resource, data);
    }

    checkSoumission(bidNo, bidModSeq) {
        const resource = urlJoin(
            CryptageFoService.base,
            'checkBidSupplier',
            'submit'
        );
        return this.http.get(resource, {
            params: new HttpParams().set('bidNo', bidNo).set('bidModSeq', bidModSeq),
        });
    }

    checkdateoffre(bidNo, bidModSeq) {
        const resource = urlJoin(
            CryptageFoService.base,
            'checkBidSupplier',
            'date'
        );
        return this.http.get(resource, {
            params: new HttpParams().set('bidNo', bidNo).set('bidModSeq', bidModSeq),
        });
    }

    checkdateoffreGroup(bidNo, bidModSeq) {
        const resource = urlJoin(
            CryptageFoService.base,
            'checkBidSupplier',
            'dateForConsor'
        );
        return this.http.get(resource, {
            params: new HttpParams().set('bidNo', bidNo).set('bidModSeq', bidModSeq),
        });
    }
}
